<template>
  <div>

    <div class=" loading-search" v-if="loading">
      <div class="fa-3x text-center">
        <i class="fas fa-circle-notch fa-spin text-success" style=""></i>
      </div>
    </div>
    <!-- BEGIN breadcrumb -->
    <ol class="breadcrumb float-xl-end">
      <li class="breadcrumb-item"><a href="javascript:;">Reportes</a></li>
      <li class="breadcrumb-item"><a href="javascript:;">RC Imperium</a></li>
      <li class="breadcrumb-item active"><a href="javascript:;">Consultar</a></li>
    </ol>

    <h1 class="page-header">Ventas <small></small></h1>



    <form @submit.prevent="search">
      <div class="row">
        <div class="col-md-8">
          <div class="form-group row">

            <div class="col-md-3">
              <label class="col-form-label">Fecha inicial</label>
              <div class="input-group">
                <date-picker id="dateTimeInput" v-model="date" :config="options"></date-picker>
                <label for="dateTimeInput" class="input-group-text">
                  <i class="fa fa-calendar"></i>
                </label>
              </div>
            </div>


            <!-- <div class="col-md-3">
              <label class="col-form-label">Fecha final</label>
              <div class="input-group">
                <date-picker id="dateTimeInputEnd" v-model="dateEnd" :config="options"></date-picker>
                <label for="dateTimeInputEnd" class="input-group-text">
                  <i class="fa fa-calendar"></i>
                </label>
              </div>
            </div> -->
          </div>
        </div>
        <div class="col-md-2">
          <button type="submit" class="btn btn-success me-1 mb-1" style="margin-top: 3.1em;">{{ textoBotonBuscar
          }}</button>
        </div>
        <div class="col-md-2">
          <button type="button" class="btn btn-primary me-1 mb-1" style="margin-top: 3.1em;"
            :disabled="loading || searchResult.length == 0" @click="Enviar">{{ textoBotonEnviar
          }}</button>
        </div>
      </div>
    </form>
    <div>
      <panel title="Ventas" bodyClass="p-0" class="" style="margin-top: 15px;">

        <DxDataGrid id="gridContainer" :data-source="searchResult" key-expr="_rowKey" :show-borders="true"
          @exporting="onExporting" :show-column-lines="true" :show-row-lines="false" :row-alternation-enabled="true"
          :column-auto-width="true">

          <DxScrolling column-rendering-mode="virtual" />
          <DxPager :show-page-size-selector="true" :allowed-page-sizes="[10, 20, 50, 100]"
            :show-navigation-buttons="true" />
          <DxPaging :page-size="10" :page-index="1" />
          <DxFilterRow />
          <DxHeaderFilter :visible="showHeaderFilter" />
          <DxSearchPanel :visible="true" :width="240" placeholder="Search..." />

          <DxGroupPanel :visible="true" />
          <DxGrouping :auto-expand-all="true" />
          <DxExport :enabled="true" :allow-export-selected-data="false" />
          <DxSelection mode="false" />


          <DxColumn data-field="UUID" caption="UUID" width="220" />
          <DxColumn data-field="Fecha" dataType="date" caption="Fecha" format="dd/MM/yyyy" />
          <DxColumn data-field="Unidad" caption="Unidad" width="80" />
          <DxColumn data-field="Cantidad" caption="Cantidad" dataType="number">
            <DxFormat type="fixedPoint" :precision="2" />
          </DxColumn>
          <DxColumn data-field="Estatus" caption="Estatus" />
          <DxColumn data-field="Subtotal" caption="Subtotal" dataType="number">
            <DxFormat type="currency" :precision="2" />
          </DxColumn>
          <DxColumn data-field="ValorUnitario" caption="Valor unitario" dataType="number">
            <DxFormat type="fixedPoint" :precision="6" />
          </DxColumn>
          <DxColumn data-field="Total" caption="Total" dataType="number">
            <DxFormat type="currency" :precision="2" />
          </DxColumn>
          <DxColumn data-field="PrecioVenta" caption="Precio venta" dataType="number">
            <DxFormat type="currency" :precision="2" />
          </DxColumn>
          <DxColumn data-field="PrecioUnitarioNeto" caption="Precio unitario neto" dataType="number">
            <DxFormat type="currency" :precision="2" />
          </DxColumn>
          <DxColumn data-field="FormaPago" caption="Forma pago" width="160" />
          <DxColumn data-field="TasaImpuesto" caption="Tasa impuesto" dataType="number">
            <DxFormat type="fixedPoint" :precision="6" />
          </DxColumn>
          <DxColumn data-field="ImporteImpuesto" caption="Importe impuesto" dataType="number">
            <DxFormat type="currency" :precision="2" />
          </DxColumn>
          <DxColumn data-field="Producto" caption="Producto" width="160" />
          <DxColumn data-field="ClienteNoCta" caption="Cliente no cta" width="120" />
          <DxColumn data-field="Cliente" caption="Cliente" width="220" />
          <DxColumn data-field="Vendedor" caption="Vendedor" width="160" />
          <DxColumn data-field="FolioFactura" caption="Folio factura" width="110" />
          <DxColumn data-field="SerieFactura" caption="Serie factura" width="110" />
          <DxColumn data-field="RFCReceptor" caption="RFC receptor" width="130" />
          <DxColumn data-field="Moneda" caption="Moneda" width="80" />
          <DxColumn data-field="TipoCambio" caption="Tipo cambio" dataType="number">
            <DxFormat type="fixedPoint" :precision="4" />
          </DxColumn>
          <DxColumn data-field="TotalFactura" caption="Total factura" dataType="number" :visible="false">
            <DxFormat type="currency" :precision="2" />
          </DxColumn>

          <DxSummary>

            <DxTotalItem column="Total" summary-type="sum" value-format="$#,##0.##" displayFormat='{0}'>
            </DxTotalItem>
            <!-- <DxTotalItem
                        column="ImporteCorte"
                        summary-type="sum"
                        value-format="$#,##0.##"
                        displayFormat='{0}'
                        >
                    </DxTotalItem>
                    <DxTotalItem
                        column="Diferencia"
                        summary-type="sum"
                        value-format="$#,##0.##"
                        displayFormat='{0}'
                        >
                    </DxTotalItem> -->
          </DxSummary>

        </DxDataGrid>

      </panel>


    </div>

    <!-- bottom left vue-notification -->
    <notifications group="top-right" position="top right" :speed="1000" />
  </div>
</template>

<script>

import axios from 'axios';
import moment from 'moment';



import {
  DxDataGrid, DxFormat, DxSummary, DxTotalItem,
  DxPaging, DxPager, DxScrolling, DxColumn, DxExport, DxSelection, DxGroupPanel, DxGrouping, DxHeaderFilter, DxFilterRow, DxSearchPanel,
} from 'devextreme-vue/data-grid';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
// Our demo infrastructure requires us to use 'file-saver-es'. We recommend that you use the official 'file-saver' package in your applications.
import { exportDataGrid } from 'devextreme/excel_exporter';
//import service from './data.js';


var numeral = require("numeral");
import Vue from "vue";

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
Vue.filter("formatNumber", function (value) {
  return numeral(value).format("0,00.00"); // displaying other groupings/separators is possible, look at the docs
});

Vue.filter("currency", function (value) {
  return numeral(value).format("$0,0.00");
});


export default {
  mounted: function () {
    var self = this;

    var userSetting = JSON.parse(localStorage.getItem('userSettings'));
    this.usuario = userSetting.Usuario;
    this.noEmpleado = userSetting.NumeroEmpleado;
    this.usuarioEstacion = userSetting.Estacion;
    this.IdRol = userSetting.IdRol;

    if (this.IdRol == 3 || this.IdRol == 7) {
      this.deshabilitarCombos = true;
    }

  },
  beforeCreate() {

  },
  created() {
    // console.log('created');
  },
  components: {
    DxTotalItem, DxDataGrid, DxSummary, DxFormat, DxPaging, DxPager, DxScrolling, DxColumn, DxExport, DxSelection, DxGroupPanel, DxGrouping, DxHeaderFilter, DxFilterRow, DxSearchPanel,
  },
  beforeMount() {
    // console.log('beforeMount');
  },
  computed: {
  },
  methods: {
    enviarCGButton(cellElement, cellInfo) {

      const button = document.createElement("button");
      button.innerText = "Abrir";
      button.className = "btn btn-sm btn-success";
      button.addEventListener("click", () => {

        this.handleButtonClick(cellInfo.data);
      });

      cellElement.appendChild(button);
    },
    handleButtonClick(data) {

      // alert(data.NoEstacion);
    },

    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('Ventas');

      exportDataGrid({
        component: e.component,
        worksheet: worksheet,
        autoFilterEnabled: true
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Ventas.xlsx');
        });
      });
      e.cancel = true;
    },
    show(group, type = '') {
      const text = this.alertMessage;
      this.$notify({
        group,
        title: this.alertTitle,
        text,
        type,
        data: {
          randomNumber: Math.random()
        }
      })
    },
    clean(group) {
      this.$notify({ group, clean: true })
    },
    swalNotification(swalType) {
      var btnClass = (swalType == 'error') ? 'danger' : swalType;
      btnClass = (swalType == 'question') ? 'primary' : btnClass;
      this.$swal({
        title: 'Are you sure?',
        text: 'You will not be able to recover this imaginary file!',
        type: swalType,
        showCancelButton: true,
        buttonsStyling: false,
        confirmButtonText: swalType.charAt(0).toUpperCase() + swalType.substr(1).toLowerCase(),
        cancelButtonText: 'Cancel',
        confirmButtonClass: 'btn me-5px btn-' + btnClass + '',
        cancelButtonClass: 'btn btn-default',
      })
    },

    buildVentasPayload() {
      return this.searchResult.map(function (item) {
        var venta = Object.assign({}, item);
        delete venta._rowKey;

        if (venta.Fecha) {
          venta.Fecha = moment(venta.Fecha).format('YYYY-MM-DD');
        }
        if (venta.FechaInicio) {
          venta.FechaInicio = moment(venta.FechaInicio).format('YYYY-MM-DDTHH:mm:ss');
        }
        if (venta.FechaFin) {
          venta.FechaFin = moment(venta.FechaFin).format('YYYY-MM-DDTHH:mm:ss');
        }

        return venta;
      });
    },

    async Enviar() {
      var self = this;

      if (self.searchResult.length == 0) {
        self.alertMessage = "No hay informacion para enviar.";
        self.alertTitle = "Error";
        self.show('top-right', 'error');
        return;
      }

      self.textoBotonEnviar = "Enviando...";
      self.loading = true;

      try {
        var dataToSend = {
          "Data": {
            "Fecha": moment(self.date).format('YYYY-MM-DD'),
            "NoEmpleado": Number(self.noEmpleado || 0),
            "Ventas": self.buildVentasPayload(),
          }
        };

        const response = await axios.post('Pegasus/SetVentas', dataToSend);

        if (response.data.Success) {
          self.alertMessage = response.data.Message;
          self.alertTitle = "Datos enviados correctamente";
          self.show('top-right', 'success');
        } else {
          self.alertMessage = response.data.Message;
          self.alertTitle = response.data.Error || "Error";
          self.show('top-right', 'error');
        }
      } catch (e) {
        self.alertMessage = "Ocurrio un error al enviar la informacion.";
        self.alertTitle = "Error";
        self.show('top-right', 'error');
      } finally {
        self.loading = false;
        self.textoBotonEnviar = "Enviar";
      }
    },

    async Buscar() {
      var self = this;
      self.textoBotonBuscar = "Buscando...";
      self.loading = true;
      try {


        const startDate = moment(self.date).format('YYYY-MM-DD');

        var dataToSend = {
          "Data": {
            "Fecha": startDate,
          }
        };
        const response = await axios.post('Pegasus/Ventas', dataToSend);

        self.loading = false;
        self.textoBotonBuscar = "Buscar";
        if (response.data.Success) {
          if (response.data.response.length == 0) {
            self.alertMessage = "No se encontró información del día especificado.";
            self.alertTitle = "Error";
            self.show('top-right', 'error');
          } else {
            self.searchResult = response.data.response.map(function (item, index) {
              return {
                ...item,
                _rowKey: item.UUID || item.Folio || item.FolioFactura || index,
                Fecha: item.Fecha ? moment(item.Fecha, 'YYYY-MM-DD').toDate() : null,
                FechaInicio: item.FechaInicio ? new Date(item.FechaInicio) : null,
                FechaFin: item.FechaFin ? new Date(item.FechaFin) : null,
                Cantidad: item.Cantidad != null ? Number(item.Cantidad) : null,
                Subtotal: item.Subtotal != null ? Number(item.Subtotal) : null,
                ValorUnitario: item.ValorUnitario != null ? Number(item.ValorUnitario) : null,
                Total: item.Total != null ? Number(item.Total) : null,
                PrecioVenta: item.PrecioVenta != null ? Number(item.PrecioVenta) : null,
                PrecioUnitarioNeto: item.PrecioUnitarioNeto != null ? Number(item.PrecioUnitarioNeto) : null,
                TasaImpuesto: item.TasaImpuesto != null ? Number(item.TasaImpuesto) : null,
                ImporteImpuesto: item.ImporteImpuesto != null ? Number(item.ImporteImpuesto) : null,
                TasaImpuestoExtra: item.TasaImpuestoExtra != null ? Number(item.TasaImpuestoExtra) : null,
                ImporteImpuestoExtra: item.ImporteImpuestoExtra != null ? Number(item.ImporteImpuestoExtra) : null,
                TotalFactura: item.TotalFactura != null ? Number(item.TotalFactura) : null,
                TipoCambio: item.TipoCambio != null ? Number(item.TipoCambio) : null,
              };
            });
          }
        } else {
          console.log("error")
          self.alertMessage = response.data.Message;
          self.alertTitle = response.data.Error;
          self.show('top-right', 'error');
        }

        self.loading = false;
      } catch (e) {
        self.loading = false;
      }
    },
    async search(e) {
      e.preventDefault();
      this.Buscar();
    }
  },
  data() {
    return {
      fromCuadreDetalle: false,
      parametrosCuadre: null,
      showHeaderFilter: true,
      RespuestaCompras: [],
      loading: false,
      deshabilitarCombos: false,
      ciudades: [],
      estaciones: [],
      ciudadSelect: 1,
      estacionSelect: 0,
      date: moment().startOf('month').format("YYYY/MM/DD"),
      intDateEnd: "",
      dateEnd: moment().format("YYYY/MM/DD"),
      intDate: "",
      options: {
        format: 'YYYY/MM/DD',
        useCurrent: false,
      },
      pageUserSettings: {},
      alertMessage: "",
      alertTitle: "",
      searchResult: [],
      textoBotonBuscar: "Buscar",
      textoBotonEnviar: "Enviar",
      noEmpleado: 0,
    };
  }
}
</script>
<style scoped>
.dx-datagrid-header-panel {
  display: none !important;
}

.loading-search {
  position: absolute;
  width: 100%;
  left: 0px;
  height: 100%;
  background: rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding-top: 150px;
  top: 0;
}

.sumatoriasRow {
  background-color: #bbb;
}

.currencyRow {
  text-align: right !important;
}

.vgt-fixed-header {
  overflow-y: auto;
}

.vgt-table__header {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: #f5f5f5;
}
</style>
